module.exports = __webpack_public_path__ + "static/media/ic_dashboard.8a5c020c.svg";